<template>
  <router-view
    #default="{ Component }"
    :key="route.path">
    <keep-alive>
      <component
        :is="Component"
        class="custom-fade"/>
    </keep-alive>
  </router-view>
</template>

<script setup>
import { useRoute } from 'vue-router'

const route = useRoute()
</script>

<style lang="scss" scoped>
.custom-fade {
  animation: appear .5s ease;
  @keyframes appear {
    0% { opacity: 0 }
    100% { opacity: 1 }
  }
}
</style>
